import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminRouter from "./admin/AdminRouter";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AdminRouter />} />
      </Routes>
    </BrowserRouter>
  );
}
